if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');
      this.swatchCount = Array.from(this.querySelectorAll('.colour-swatch-links--desktop .swatch')).length;
      this.firstImage = this.querySelector('.product-card__imagePlaceholder');
      this.secondImage = this.querySelector('.product-card__secondImagePlaceholder');

      this.additionalSwatches = this.querySelector('.additional-swatches');
      this.additionalSwatchesTrigger = this.querySelector('.swatch-additional');
      this.additionalSwatchesTriggerBtn = this.querySelector('.swatch-additional button');

      this.titlePriceContainer = this.querySelector('.product-card__titlePrice');
      this.productLabelTag = this.querySelector('.product-card-text-badge');

      this.boundHandleSwatchClick = this.handleSwatchClick.bind(this);
      this.boundHandleAdditionalSwatchesClick = this.handleAdditionalSwatchesClick.bind(this);
      this.quickshopBtns = this.querySelectorAll('.quickshop-btn');
      this.link = this.querySelector('.product-card__link');

      this.badgeData = this.loadBadgeData();
      this.mql = window.matchMedia('(max-width: 991px)'); 
    }

    loadBadgeData() {
      const badgeScript = this.querySelector('.product-badge-data');
      if (!badgeScript) return null;

      try {
        return JSON.parse(badgeScript.textContent);
      } catch (e) {
        console.error('Failed to parse badge data:', e);
        return null;
      }
    }

    connectedCallback() {
      // const titleLength = this.querySelector('.product-card__titleLink').textContent.length;
      // const titleWidth = this.querySelector('.product-card__titleLink').offsetWidth;

      // if (window.innerWidth < 768) {
      //   if (titleLength >= 21) {
      //     this.classList.add('product-card--showMinHeightMobile');
      //     return;
      //   }
      // } else if (titleWidth && titleWidth < 390) {
      //   if (titleLength >= 32) {
      //     this.classList.add('product-card--showMinHeightDesktop');
      //     return;
      //   }
      // }

      if (this.swatchCount >= 6) {
        this.initSwatchSlider();
      }

      this.querySelectorAll('.swatch:not(.swatch-additional)').forEach((swatch) => {
        swatch.addEventListener('click', this.boundHandleSwatchClick);
      });

      if (this.additionalSwatchesTrigger) {
        this.additionalSwatchesTrigger.addEventListener('click', this.boundHandleAdditionalSwatchesClick);
      }
    }

    disconnectedCallback() {
      if (this.swatchSlider) {
        this.swatchSlider.destroy();
      }

      this.querySelectorAll('.swatch').forEach((swatch) => {
        swatch.removeEventListener('click', this.boundHandleSwatchClick);
      });

      if (this.additionalSwatchesTrigger) {
        this.additionalSwatchesTrigger.removeEventListener('click', this.boundHandleAdditionalSwatchesClick);
      }
    }

    initSwatchSlider() {
      const prevBtn = this.querySelector('.swiper-btn-prev');
      const nextBtn = this.querySelector('.swiper-btn-next');

      this.swiperEl.dataset.arrowMode = 'forward';

      this.swatchSlider = new Swiper(this.swiperEl, {
        slidesPerView: 'auto',
        nested: true,
        spaceBetween: 1,
        watchOverflow: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          992: {
            cssMode: false,
            slidesPerView: 6,
            spaceBetween: 8,
            slidesPerGroup: 6,
          },
        },
        on: {
          reachEnd: () => {
            this.swiperEl.dataset.arrowMode = 'backward';
          },
          reachBeginning: () => {
            this.swiperEl.dataset.arrowMode = 'forward';
          },
        },
      });
    }

    handleSwatchClick(e) {
      const swatch = e.target.closest('.swatch');
      const swatchBtn = swatch.querySelector('button');

      if (!swatchBtn || !this.firstImage || !this.secondImage) return;

      const url = swatchBtn.dataset.swatchUrl;
      this.link.href = url;

      this.handleUpdatePrice(swatchBtn, swatch);

      if (this.quickshopBtns && this.quickshopBtns.length > 0) {
        this.quickshopBtns.forEach((btn) => {
          btn.dataset.productHandle = swatchBtn.dataset.swatchUrl.split('/products/')[1].split('?')[0];
        });
      }

      this.querySelectorAll('button.is-selected').forEach(btn => btn.classList.remove('is-selected'));
      swatchBtn.classList.add('is-selected');

      const swatchImage = swatchBtn.dataset.swatchImg;
      const swatchSecondImage = swatchBtn.dataset.swatchImgSecond;

      this.firstImage.src = swatchImage;
      this.secondImage.src = swatchSecondImage;

      this.updateBadge(swatchBtn);
      this.updateDiscountBadge(swatchBtn);
    }

    handleUpdatePrice(el, swatch) {
      if (!this.titlePriceContainer) return;

      const regularPrice = el.dataset.productPrice;
      const compareAtPrice = el.dataset.productCompare;
      const discountedPrice = el.dataset.discountedPrice;
      const discountPercentage = el.dataset.discountPercentage;

      let textDiscountedPrice = discountedPrice;

      const discountedPriceRoundedToZero = Math.floor(discountedPrice * 10) % 10 === 0;
      if (discountedPriceRoundedToZero) {
        textDiscountedPrice = parseFloat(discountedPrice).toFixed(0);
      } else {
        textDiscountedPrice = parseFloat(discountedPrice).toFixed(2);
      }

      const isOnSale = this.dataset.onSale;
      const metaDiscountType = swatch.dataset.metaDiscountType;

      const hasCustomSaleStyles = this.titlePriceContainer.classList.contains('custom-sale-styles');
      const customStylesHTML = hasCustomSaleStyles
        ? `<span class="custom-sale-label">Now ${(((compareAtPrice - regularPrice) * 100) / compareAtPrice).toFixed(0)}% off</span>`
        : '';

      if (swatch.dataset.metaDiscountValue && swatch.dataset.metaDiscountValue != 0) {
        this.titlePriceContainer.textContent = '';

        const badgeHTML =
          swatch.dataset.metaBadgeText && swatch.dataset.metaBadgeText.trim() !== ''
            ? `<span class="flash-sale-badge-and-price">
               <span class="flash-sale-badge">
                 ${swatch.dataset.metaBadgeText}
               </span>
             </span>`
            : '';

        let metaDiscountedPrice = regularPrice;

        if (swatch.dataset.metaDiscountType == 'Percentage') {
          metaDiscountedPrice = (regularPrice * (1 - swatch.dataset.metaDiscountValue / 100)).toFixed(2);
        } else {
          metaDiscountedPrice = regularPrice - swatch.dataset.metaDiscountValue;
        }

        this.titlePriceContainer.innerHTML += `
          <span class="card-price-val">$${regularPrice}</span> 
          ${badgeHTML}
          <span class="flash-sale-price">
            $${metaDiscountedPrice} after ${metaDiscountType == 'Percentage' ? `${swatch.dataset.metaDiscountValue}% off` : `$${swatch.dataset.metaDiscountValue} off`} 
          </span>
        `;
      } else if (discountedPrice == 0) {
        if (compareAtPrice == regularPrice || compareAtPrice == 0) {
          this.titlePriceContainer.textContent = `$${regularPrice}`;
        } else if (compareAtPrice != regularPrice && compareAtPrice != 0) {
          this.titlePriceContainer.textContent = '';
          this.titlePriceContainer.innerHTML = `
              <span class='on-sale'>
                <span class='sale-price'> 
                  $${regularPrice}
                  <s>$${compareAtPrice}</s>
                </span>
              </span>
              ${customStylesHTML}
            `;
        }
      } else {
        if (compareAtPrice == regularPrice || compareAtPrice == 0) {
          this.titlePriceContainer.textContent = '';
          this.titlePriceContainer.innerHTML = `
              <s>$${regularPrice}</s>
              <div class="global-discount">$${textDiscountedPrice} <span class="global-discount-text">after ${discountPercentage} off</span></div>  
            `;
        } else {
          this.titlePriceContainer.textContent = '';
          this.titlePriceContainer.innerHTML = `
              <span class='on-sale'>
                <span class='sale-price'> 
                  <s>$${compareAtPrice}</s>
                  <s>$${regularPrice}</s>
                </span>
              </span>
              <div class="global-discount">$${textDiscountedPrice} <span class="global-discount-text">after ${discountPercentage} off</span></div>  
            `;
        }
      }
    }

    updateBadge(swatchBtn) {
      const labelTagText = swatchBtn?.dataset?.swatchBadge || '';
      const productCardTextBadge = this.querySelector('.product-card-text-badge');
      if(productCardTextBadge){
        productCardTextBadge.textContent = labelTagText;
      }
    }
    updateDiscountBadge(swatchBtn){
      const discountBadgeText = swatchBtn?.dataset?.discountBadge || '';
      const discountBadge = this.querySelector('.bulk-discount__badge-slider');
      if(discountBadge){
        discountBadge.textContent = discountBadgeText;
      }
    }

    handleAdditionalSwatchesClick(e) {
      if (!this.additionalSwatches) return;

      if (this.additionalSwatches.classList.contains('expanded')) {
        this.additionalSwatches.style.maxHeight = '0px';
        this.additionalSwatches.classList.remove('expanded');
        this.additionalSwatchesTriggerBtn.setAttribute('aria-expanded', 'false');
      } else {
        this.additionalSwatches.style.maxHeight = this.additionalSwatches.scrollHeight + 'px';
        this.additionalSwatches.classList.add('expanded');
        this.additionalSwatchesTriggerBtn.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('product-card', ProductCard);
}
